import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

export const getContactsOptions = (contacts, isNewRecord) => {
    let items = contacts.map((item) => {
        return {
            label: item.name,
            value: item.id,
        };
    });

    if (isNewRecord)
        items.unshift({
            label: i18next.t('New contact'),
            value: 'new_contact',
        });

    return [
        {
            disabled: true,
            label: i18next.t('Select'),
            value: '',
        },
        ...items,
    ];
};

export const getCity = (address_components) => {
    let filter = address_components.filter(
        (item) => item.types.toString() == ['locality', 'political'].toString(),
    );
    if (!isEmpty(filter)) return filter[0]?.long_name || '';
};

export const getState = (address_components) => {
    let filter = address_components.filter(
        (item) =>
            item.types.toString() ==
            ['administrative_area_level_1', 'political'].toString(),
    );
    if (!isEmpty(filter)) return filter[0]?.long_name || '';
};

export const getCountry = (address_components) => {
    let filter = address_components.filter(
        (item) => item.types.toString() == ['country', 'political'].toString(),
    );
    if (!isEmpty(filter)) return filter[0]?.long_name || '';
};
